import { Email as EmailIcon, Phone as PhoneIcon } from "@mui/icons-material";
import { Grid, Link, Stack, TextField } from "@mui/material";
import type { FC } from "react";
import { useAgentWithId } from "../../admin/agents/useAgentWithId";
import { useCustomerWithId } from "../../customers/useCustomerWithId";
import dayjs from "../../dayjs";

interface Props {
  readonly supervisorId: string | undefined;
  readonly customerId: string;
  readonly order: {
    readonly id: number;
    readonly name: string;
    readonly startDate: string;
  };
}

const SupervisorInfo: FC<Props> = ({ supervisorId, customerId, order }) => {
  const { customer } = useCustomerWithId(customerId);
  const { data: agent } = useAgentWithId(supervisorId ?? customer?.accountManager?.id);
  const startDate = dayjs(order.startDate).format("DD.MM.YYYY");
  return (
    <Grid container spacing={2}>
      <Grid size={6}>
        <TextField
          label="Opiekun"
          fullWidth
          value={agent?.name}
          slotProps={{
            input: { readOnly: true },
            inputLabel: { shrink: true },
          }}
        />
      </Grid>
      {agent && (
        <Grid container size={6} spacing={1}>
          <Grid size={12}>
            <Stack
              direction="row"
              spacing={1}
              sx={{
                alignItems: "center",
              }}
            >
              <EmailIcon />
              <Link
                variant="body2"
                href={`mailto:${agent.contact.przezmorzeEmail}?subject=${encodeURIComponent(
                  `${order.id}: ${order.name} - ${startDate}`,
                )}`}
              >
                {agent.contact.przezmorzeEmail}
              </Link>
            </Stack>
          </Grid>
          <Grid size={12}>
            <Stack
              direction="row"
              spacing={1}
              sx={{
                alignItems: "center",
              }}
            >
              <PhoneIcon />
              <Link variant="body2" href={`tel:${agent.contact.phone}`}>
                {agent.contact.phone}
              </Link>
            </Stack>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default SupervisorInfo;
